import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "./auth.state";

export const selectAuthState = createFeatureSelector<AuthState>("auth");

export const selectAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state.auth,
);

export const selectUser = createSelector(
    selectAuthState,
    (state: AuthState) => state.user,
);

export const selectAuthError = createSelector(
  selectAuthState,
  (state: AuthState) => {
    return state.httpError?.message;
  },
);


export const selectUserAvatarId = createSelector(
  selectAuthState,
  (state: AuthState) => {
    return state.user?.id;
  },
);

export const selectAuthLoading = createSelector(
  selectAuthState,
  (state: AuthState) => {
    return state.httpEventLoading;
  },
);

export const selectRouterState = createSelector(
  selectAuthState,
  (state: AuthState) => {
    return state.routerState;
  },
);


export const selectAuthIsReady = createSelector(
    selectAuthState,
    (state: AuthState) => {
        return {
            authReady: state.authReady,
            user: state.user,
            isGuest: state.isGuest
        }
    },
);
